import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { HttpClientModule } from '@angular/common/http';

import { ConfigLoader } from './configLoader';
import { PopoverComponent } from '../app/popover/popover.component';
//import { Network } from '@ionic-native/network/ngx';

import { APP_INITIALIZER } from '@angular/core';
import { ConfigService } from './config.service';

import { IonicStorageModule } from '@ionic/storage-angular';

import { CommonModule } from '@angular/common'; 

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, CommonModule, IonicModule.forRoot(), AppRoutingModule, HttpClientModule, IonicStorageModule.forRoot()],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    ConfigService,
    {
      provide   : APP_INITIALIZER,
      useFactory: ConfigLoader,
      deps      : [ConfigService],
      multi     : true
    },
  ],
  
  bootstrap: [AppComponent],
})
export class AppModule {}
